import { SVGIconComponent } from './types';

export const BoolYes: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="45px"
    height="45px"
    viewBox="0 0 45 45"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M22.461,44.922 C10.074,44.922 0,34.848 0,22.461 C0,10.074 10.074,0 22.461,0 C34.848,0 44.922,10.074 44.922,22.461 C44.922,34.848 34.848,44.922 22.461,44.922 Z M22.461,3.906 C12.231,3.906 3.906,12.2302 3.906,22.461 C3.906,32.691 12.2302,41.016 22.461,41.016 C32.691,41.016 41.016,32.6918 41.016,22.461 C41.016,12.231 32.6918,3.906 22.461,3.906 Z"
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
      <path
        d="M16.016,33.203199 C15.930063,33.203199 15.84022,33.195187 15.75038,33.183469 C15.1371,33.101437 14.60198,32.730349 14.30508,32.191279 L10.00818,24.378779 C9.48865,23.433469 9.8324,22.245979 10.77771,21.726479 C11.72302,21.206949 12.91051,21.550699 13.43001,22.496009 L16.45731,28.003809 L31.80531,12.308809 C32.55922,11.539279 33.79751,11.523649 34.56701,12.277559 C35.33654,13.031469 35.35217,14.269759 34.59826,15.039259 L17.41026,32.617259 C17.04307,32.992259 16.53917,33.203199 16.01576,33.203199 L16.016,33.203199 Z"
        id="Path"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
